// Static asset URLs
// hero-challenger.png = the customer-supplied cartoon Challenger silhouette (transparent PNG)
// srt-finder-logo.png = the customer-supplied red splatter SRT Finder wordmark (transparent PNG)
// /brand/srt-finder-logo.png = the crosshair Challenger badge (full brand mark, black bg)
// /brand/hero-intro.mp4 = auto-playing landing intro that morphs into the logo
export const BURNOUT_HERO = "/hero-challenger.png";
export const SRT_LOGO = "/srt-finder-logo.png";
export const SRT_BRAND_MARK = "/brand/srt-finder-logo.png";
export const SRT_HERO_INTRO = "/brand/hero-intro.mp4";
